import { render, staticRenderFns } from "./BusinessUnits.vue?vue&type=template&id=32ee8d7f&"
import script from "./BusinessUnits.vue?vue&type=script&lang=ts&"
export * from "./BusinessUnits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports